<form [formGroup]="formGroup" *ngIf="initialized" style="height: 100%;">
    <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" class="no-field-space article-price-editor">
        <sc-flex>
            <mat-radio-group formControlName="calculationMode">
                <mat-radio-button value="{{calculationModeArticleBased}}">Artikelbasiert</mat-radio-button>
                <mat-radio-button value="{{calculationModeManualAmount}}">Manuelle Menge</mat-radio-button>
                <mat-radio-button value="{{calculationModeManual}}">Komplett Manuell</mat-radio-button>
                <mat-radio-button value="{{calculationModeFixed}}">Festpreis</mat-radio-button>
            </mat-radio-group>
            <sc-content-spacer [grow]="true"></sc-content-spacer>
            <mat-form-field appearance="fill">
                <mat-label>{{ 'EK Source' | translate: ['erp.entity.projectposition.costsprice-source',
                    translationService.language]}}</mat-label>
                <mat-select formControlName="costsPriceSource">
                    <mat-option *ngFor="let source of availableCostsPriceSources" [value]="source">
                        {{source}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </sc-flex>

        <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>

        <sc-separator-line></sc-separator-line>

        <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
        <ng-container *ngIf="!isPriceFixedVisible">
            <sc-flex>
                <sc-content-spacer [grow]="true"></sc-content-spacer>
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'Netto' | translate: ['erp.entity.price.price-net',
                        translationService.language]}}</mat-label>
                    <span matSuffix>€</span>
                    <input matInput acNumberInput [scale]="priceScale" formControlName="price_net">
                </mat-form-field>
                <ng-container *ngIf="!hideVatPrices">

                    <sc-content-spacer></sc-content-spacer>
                    <mat-form-field appearance="fill">
                        <mat-label>{{ 'MwSt (%)' | translate: ['erp.entity.price.tax-rate',
                            translationService.language]}}</mat-label>
                        <input matInput acNumberInput [scale]="0" formControlName="tax_rate">
                        <span matSuffix>%</span>
                    </mat-form-field>
                    <sc-content-spacer></sc-content-spacer>
                    <mat-form-field appearance="fill">
                        <mat-label>{{ 'Brutto' | translate: ['erp.entity.price.price-vat',
                            translationService.language]}}</mat-label>
                        <input matInput acNumberInput [scale]="priceScale" formControlName="price_vat">
                        <span matSuffix>€</span>
                    </mat-form-field>
                </ng-container>
            </sc-flex>
            <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
            <sc-separator-line></sc-separator-line>

            <sc-flex-fitting-content [vertical]="true">
                <sc-scroll-pane>
                    <ng-container *ngIf="!(articleType?.calculationRules?.length>0)">
                        <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
                        {{ 'no calculation rules available' | translate:
                        ['erp.ui.projectposition-editor.label.no-calculation-rules-available',
                        translationService.language]}}
                    </ng-container>
                    <ng-container *ngFor="let rule of articleType?.calculationRules; let i = index">
                        <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
                        <sc-flex>
                            <sc-icon iconClass="fa-plus fa-2x" *ngIf="rule.method == 'ADD'"></sc-icon>
                            <sc-icon iconClass="fa-minus fa-2x" *ngIf="rule.method == 'SUBTRACT'"></sc-icon>
                            <sc-content-spacer></sc-content-spacer>
                            <app-dictionary-entry-label [model]="rule.name"></app-dictionary-entry-label>
                            <sc-content-spacer [grow]="true"></sc-content-spacer>
                            <mat-form-field appearance="fill" class="number-field">
                                <mat-label>{{ 'Count' | translate: ['erp.entity.calculationrule.count',
                                    translationService.language]}}
                                </mat-label>
                                <input matInput acNumberInput [scale]="2" [formControlName]="'rule_count_' + rule.id">
                            </mat-form-field>
                            <sc-content-spacer></sc-content-spacer>
                            <sc-icon iconClass="fa-xmark fa-2x"></sc-icon>
                            <sc-content-spacer></sc-content-spacer>
                            <mat-form-field appearance="fill" class="number-field">
                                <mat-label>{{ 'Faktor' | translate: ['erp.entity.calculationrule.factor',
                                    translationService.language]}}
                                </mat-label>
                                <input matInput acNumberInput [scale]="3" [formControlName]="'rule_faktor_' + rule.id">
                            </mat-form-field>
                            <sc-content-spacer></sc-content-spacer>
                            <sc-icon iconClass="fa-equals fa-2x"></sc-icon>
                            <sc-content-spacer></sc-content-spacer>
                            <div class="sum-column">
                                {{ calculationResults.get(rule.id) | numberFormat:priceScale}}
                            </div>
                        </sc-flex>
                    </ng-container>
                    <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
                </sc-scroll-pane>
            </sc-flex-fitting-content>

            <sc-separator-line></sc-separator-line>

            <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>

            <div class="resulting-price">
                <sc-flex [stretchContent]="true">
                    <div>{{ 'Resultierender Preis' | translate:
                        ['erp.ui.projectposition-editor.label.resulting-price',
                        translationService.language]}}</div>
                    <sc-content-spacer [grow]="true"></sc-content-spacer>
                    <div *ngIf="resultingPriceNet != null">{{resultingPriceNet | numberFormat:priceScale}} €
                    </div>
                </sc-flex>
            </div>
        </ng-container>
        <ng-container *ngIf="isPriceFixedVisible">
            <sc-flex>
                <sc-content-spacer [grow]="true"></sc-content-spacer>
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'fixed price' | translate: ['erp.entity.projectposition.price-fixed',
                        translationService.language]}}</mat-label>
                    <span matSuffix>€</span>
                    <input matInput acNumberInput [scale]="priceScale" formControlName="price_fixed">
                </mat-form-field>
            </sc-flex>
        </ng-container>
    </sc-flex>
</form>
